(function() {
    'use strict';

    window.Coop = window.Coop || { Modules: {} };

    Coop.Modules.LocationSearch = {
        defaults: {
            searchRadius: window.SEARCH_RADIUS || 10000
        },
        errorMessages: {
            enterTownPostcode: 'Please enter town or postcode and try again',
            noBranchesFound: 'We cannot find any funeral homes near this location'
        },
        triggerIds: {
            processingStart: 'processingStart',
            processingDone: 'processingDone'
        },
        init: function() {
            window.locationSearch = this;

            this.$form = $('.finder-form');
            this.$input = $('#q');

            this.searchHistory = {};
            this.business = window.SEARCH_BUSINESS;
            this.baseURL = window.SEARCH_RESULT_URL;
            this.minResults = 5;

            this.currentView = null;
            this.currentSearch = {
                address: null,
                coords: null,
                radius: this.defaults.searchRadius,
                min_distance: 0,
                locality: null,
                results: []
            };

            this.initServerSideResults();
            this.bindEvents();
        },
        initServerSideResults: function() {
            var self = this;

            if (window.SEARCH_LOCATION) {
                this.currentSearch.address = this.$input.val();
                this.currentSearch.coords = {
                    latitude: window.SEARCH_LOCATION.latitude,
                    longitude: window.SEARCH_LOCATION.longitude
                };
                this.currentSearch.locality = window.SEARCH_LOCATION.locality;

                $('.store-item').each(function() {
                    self.currentSearch.results.push({
                        name: $('.store-name', this).text(),
                        distance: {
                            m: $('[data-distance-metres]', this).data('distance-metres')
                        }
                    });
                });
                var currentView = $('.finder-results-list').is(':visible') ? '#list' : '#map';
                var title = 'Funeral homes' + ' near ' + this.currentSearch.locality + ' - Co-op';
                var data = {
                    address: this.currentSearch.locality,
                    coords: {
                        latitude: this.currentSearch.coords.latitude,
                        longitude: this.currentSearch.coords.longitude
                    },
                    locality: this.currentSearch.locality,
                    view: currentView
                };
                window.history.pushState(data,
                    title,
                    this.baseURL +
                    encodeURI(this.currentSearch.address).replace(/%20/g, '+') +
                    this.getQueryString()
                );
            }
        },
        reset: function() {
            this.$form.removeClass('finder-form-compact');
            $('body').addClass('finder-landing').removeClass('list-view map-view');
            this.$input.val('');

            locationsList.clearList();
            locationsMap.resetMap();

            this.currentView = null;
            this.currentSearch = {
                address: null,
                coords: null,
                radius: this.defaults.searchRadius,
                min_distance: 0,
                locality: null,
                results: []
            };

            $(window).trigger('resize');
        },
        bindEvents: function() {
            var self = this;
            var state = window.history.state;

            if (!window.historyListenerSetup) {
                window.historyListenerSetup = true;

                if (this.currentSearch.address && typeof SEARCH_LOCATION !== 'undefined') {
                    var widen = state.radius,
                        selectedMarker = state.selectedMarker;

                    this.addToSearchHistory(this.currentSearch.address, SEARCH_LOCATION);
                    this.updateSearchRadius();

                    if (widen) {
                        this.widenSearch(widen);
                    }
                    if (selectedMarker) {
                        locationsMap.selectMarker(selectedMarker);
                    }
                }
            }

            this.$form
                .off('submit.locationSearch')
                .on('submit.locationSearch', function(e) {
                    var address = self.$input.val().trim() || window.finderInput;

                    e.preventDefault();
                    self.removeErrorMessaging();
                    window.finderInput = null;

                    if (!address || !address.trim()) {
                        self.addBasicErrorMessage(self.errorMessages.enterTownPostcode);
                    }
                    else {
                        Coop.Modules.Geolocator.currentLocation = null;

                        if (self.searchHistory.hasOwnProperty(address)) {
                            self.addToSearchHistory(address, self.searchHistory[address]);
                        }
                        else {
                            Coop.Modules.Geolocator.coordinatesFromAddress(address, function(location_data) {
                                self.addToSearchHistory(address, location_data);
                            });
                        }
                    }
                })
                .on(self.triggerIds.processingStart, function() {
                    $(this).addClass('loading').find('.finder-submit').addClass('btn-loading');
                })
                .on(self.triggerIds.processingDone, function() {
                    $(this).removeClass('loading').find('.finder-submit').removeClass('btn-loading');
                });

            this.$input
                .off('keydown.removeError focus.removeError change.removeError')
                .on('keydown.removeError focus.removeError change.removeError', function() {
                    if ($(this).hasClass('invalid') && $(this).val()) {
                        self.removeErrorMessaging();
                    }
                });
        },
        getQueryString: function() {
            return window.location.search;
        },
        renderHistory: function() {
            var state = window.history.state;

            var maxResultsToShow = 2;
            this.removeErrorMessaging();
            if (state.coords && state.address !== this.currentSearch.address) {
                // New address: perform a brand new search.

                locationsList.clearList();
                locationsMap.clearMap();

                this.currentSearch = {
                    address: state.address,
                    coords: state.coords,
                    locality: state.locality,
                    radius: state.radius || this.defaults.searchRadius,
                    min_distance: 0,
                    results: []
                };

                this.$input.val(state.address);
                this.doSearch(maxResultsToShow);
            }
            else if (state.coords && state.radius && state.radius > this.currentSearch.radius) {
                this.widenSearch(state.radius);
            }

            if (state.view && state.view !== this.currentView) {
                this.currentView = state.view;

                if (typeof Coop.Modules.mobileTabs.$tabs === 'undefined') {
                    Coop.Modules.mobileTabs.init();
                }

                Coop.Modules.mobileTabs.activateTab(this.currentView);
            }

            if (!state.view && !state.coords) {
                this.reset();
            }
        },
        addBasicErrorMessage: function(msg) {
            this.removeErrorMessaging();
            this.$input.addClass('invalid');
            this.$form.find('.form-wrapper-fnc').before(
                '<p role="alert" class="form-error">' + msg + '</p>'
            );
            $(window).trigger('resize');
        },
        removeErrorMessaging: function() {
            this.$input.removeClass('invalid');
            $('.form-error', this.$form).remove();
            $(window).trigger('resize');
        },
        addToSearchHistory: function(address, location_data) {
            var currentView = $('.finder-results-list').is(':visible') ? '#list' : '#map',
                title = 'Funeral homes' + ' near ' + address + ' - Co-op',
                data = {
                    address: address,
                    coords: {
                        latitude: location_data.latitude,
                        longitude: location_data.longitude
                    },
                    locality: location_data.locality,
                    view: currentView
                };

            this.searchHistory[address] = location_data;
            window.history.pushState(data, title,
                this.baseURL +
                encodeURI(address).replace(/%20/g, '+') +
                this.getQueryString()
            );
            this.renderHistory();
        },
        doSearch: function(noOfResults) {
            var self = this;
            var coords = this.currentSearch.coords;
            var params = {
                location: coords.latitude + ',' + coords.longitude,
                distance: this.currentSearch.radius,
                min_distance: this.currentSearch.min_distance,
                min_results: this.minResults
            };

            this.$form.trigger(self.triggerIds.processingStart);

            locationService.getStores(this.business, params, function(data) {

                Coop.Modules.PagingResults.init(data.results, noOfResults);
                var results = Coop.Modules.PagingResults.getCurrentItems();
                self.currentSearch.results = self.currentSearch.results.concat(results);
                self.useResults(results);
                self.updateSearchRadius();
            });
        },
        widenSearch: function(radius) {
            var state = window.history.state;
            var maxResultsToShow = 5;

            this.currentSearch.min_distance = this.currentSearch.radius;

            if (radius) {
                this.currentSearch.radius = radius;
            }
            else {
                this.currentSearch.radius += this.defaults.searchRadius;
            }

            state.radius = this.currentSearch.radius;

            if (state.selectedMarker) {
                locationsList.closePanel();
                delete state.selectedMarker;
            }

            this.doSearch(maxResultsToShow);

            window.history.markerOptions(state, state.title, state.url);
        },
        useResults: function(results) {
            locationsList.populateList(results);

            locationsMap.renderSearchLocationMarker(this.currentSearch.coords.latitude, this.currentSearch.coords.longitude, !!Coop.Modules.Geolocator.currentLocation);
            locationsMap.populateMap();

            if (results.length === 0) {
                locationSearch.addBasicErrorMessage(this.errorMessages.noBranchesFound);
            }
            else {
                this.$form.addClass('finder-form-compact');
                $('body').removeClass('finder-landing').addClass('finder-results');
            }

            this.$form.trigger(this.triggerIds.processingDone);
            $(window).trigger('resize');
        },
        updateSearchRadius: function() {
            var state,
                results = this.currentSearch.results || [];

            if (results.length && results[results.length - 1].distance.m > this.currentSearch.radius) {
                state = window.history.state;
                this.currentSearch.radius = results[results.length - 1].distance.m + 1;
                state.radius = this.currentSearch.radius;
                window.history.replaceState(state, state.title, state.url);
            }
        }
    };
})();
